import React from 'react';
import ReactConfetti from 'react-confetti';

interface GameConfettiProps {
  width: number;
  height: number;
}

const GameConfetti: React.FC<GameConfettiProps> = ({ width, height }) => {
  return (
    <ReactConfetti
      width={width}
      height={height}
      recycle={true}
      numberOfPieces={200}
      gravity={0.3}
      colors={['#FFC107', '#FFD700', '#FFA500', '#FF8C00']}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        zIndex: 30
      }}
    />
  );
};

export default GameConfetti; 